module.exports = __webpack_public_path__ + "img/kepegawaian.9d4866ff.svg";